<template>
  <router-view
    id="app"
    :student-id.sync="studentId"
    :public-level="publicLevel"
    :agent-id="agentId"
    :fk-platform-type="fkPlatformType"
    :lang="lang"
    :interceptors-request="interceptorsRequest"
    :at="at"
    :isBmsLogin="isBmsLogin"
    :companyId="companyId"
    :issueInnerAccount="issueInnerAccount"
  />
</template>

<script>
import { loginByPwd } from "@/api/common.js";
export default {
  data() {
    return {
      studentId: process.env.NODE_ENV == "development" ? 55266 : null,
      publicLevel: "5",
      agentId: 3,
      fkPlatformType: "get_issue",
      lang: "zh",
      interceptorsRequest: null,
      at: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJnZW5kZXIiOjEsInVzZXJfbmFtZSI6IjEzNzI3NDExNDc1IiwiZmtBcmVhQ291bnRyeUlkTmF0aW9uYWxpdHkiOm51bGwsImNvbXBhbnlBY2NvdW50VHlwZSI6bnVsbCwibXNvVXNlclR5cGUiOm51bGwsImNsaWVudF9pZCI6Im1zb0NlbnRlciIsImlzX2FkbWluIjoiZmFsc2UiLCJvc3NGaWxlc1VybCI6bnVsbCwic2NvcGUiOlsiYWxsIl0sInN0YWZmX2lkIjoiNDIzMTciLCJ1c2VySGVhZEljb24iOm51bGwsIm9hdXRoX2lkIjoiIiwiZmtfY29tcGFueV9pZCI6IiIsImV4cCI6MTc2MTIxMDQwNSwianRpIjoiMmMwY2EwZWQtM2FmZS00OGVkLTg4YzEtOGIyN2ZiZTRhMWE1IiwibG9naW5faWQiOiIxMzcyNzQxMTQ3NSIsIm9zc0ltYWdlc1VybCI6bnVsbCwiaXNfYWN0aXZlIjoidHJ1ZSIsIm9wZW5pZCI6bnVsbCwic2Vzc2lvbl9pZCI6IjljYjkwMGVkN2JiZjRlZGE4ZmFmZDJlNTlkMWMzYzg2IiwiaXNzdWVTb3VyY2UiOm51bGwsImF1dGhvcml0aWVzIjpbIjQyMzE3Il0sIndlY2hhdF9vcGVuaWQiOiJvcjRnNTVFRVdKUnB3ZnpSNE9BeUpGRlpCZThjLG94UWlPNUZYdjFRelRLOTIxcDBLY3Q4blptR1Esb3g1UHg1WjE4WktweTlEdkxlWVJTbU50VVBpUSIsImxpY2Vuc2UiOiJHRVQiLCJsb2dpbl90aW1lIjoxNzYxMTI0MDA1OTAzLCJuYW1lIjoidmljayIsImZrX3BsYXRmb3JtX3R5cGUiOiJnZXRfbXNvIn0.dKQVE84fzmLv4_aYqRJIwBeE0poofUWA1mIEVIW0RE0",
      authorization: "",
      loginPs: "",
      loginId: "",
      isAndroid: true,
      isBmsLogin: true,
      companyId: 2,
      issueInnerAccount: true,
    };
  },
  created() {
    window.RNLogin = (data)=>{
      this.receiveMessage(data)
    }
  },
  methods: {
    async receiveMessage(data) {
      let {
        studentId,
        publicLevel,
        agentId,
        fkPlatformType,
        lang,
        loginPs,
        loginId,
      } = data;
      if (data.type !== "msoApp") return;
      lang = lang || "zh";
      fkPlatformType = fkPlatformType || "get_mso";
      try {
        const ret = await loginByPwd({
          loginId,
          loginPs,
          fkPlatformType: "get_mso",
        });
        if (ret.data.code !== "1003") {
          this.$msge.error('login fail')
          window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: "error",
                message: "login fail",
              })
            );
          return;
        }
        this.$msge.success('login success')
        this.studentId = studentId;
        this.publicLevel = publicLevel;
        this.agentId = agentId;
        this.fkPlatformType = fkPlatformType;
        this.lang = lang;
        window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: "connected",
              studentId: studentId,
            })
          );
      } catch {
        this.$msge.error('login fail')
        window.ReactNativeWebView &&
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: "error",
              message: "login fail",
            })
          );
      }
    },
  },
};

</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
body{
  background-color: #f1f1f1;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
@media screen and(max-width: 768px) {
  .stu-all-form-info {
    .forms-box {
      padding: 0 12px;
    }
  }
}
</style>